import React from "react";


function Header () {
    return (
        <div className="header">
            <div className="logo-wrapper">
                <img src="./images/logo.png"className="logo"/> 
            </div>
            <div className="services-wrapper">
                <div>interpreter</div>
                <div>sign instructor</div>
                <div>sign content</div>
                <div>sign facilitator</div>
            </div>
        </div>
    );
}



export default Header